import React from 'react';
import { Chip } from '@mui/material';
import { Email, Sms, NotificationsActive } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export const CHANNEL_META = {
    email: { color: 'info',      labelEn: 'Email', labelAr: 'بريد إلكتروني', Icon: Email },
    sms:   { color: 'success',   labelEn: 'SMS',   labelAr: 'رسالة نصية',     Icon: Sms },
    push:  { color: 'secondary', labelEn: 'Push',  labelAr: 'إشعار',          Icon: NotificationsActive },
};

const ChannelBadge = ({ channel, sx }) => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');
    const meta = CHANNEL_META[channel] || {
        color: 'default',
        labelEn: channel || '-',
        labelAr: channel || '-',
        Icon: null,
    };
    const Icon = meta.Icon;

    return (
        <Chip
            icon={Icon ? <Icon sx={{ fontSize: 16 }} /> : undefined}
            label={isArabic ? meta.labelAr : meta.labelEn}
            size="small"
            color={meta.color}
            variant="tonal"
            sx={{ fontWeight: 'bold', borderRadius: '6px', minWidth: 80, ...sx }}
        />
    );
};

export default ChannelBadge;
